module.exports = __webpack_public_path__ + "static/media/09_MEDS-1.9-ES-14.0-TI_1.33fea439.png";